import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Personne } from 'src/app/models/personne';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'solderdepotmodal',
  templateUrl: './solderdepotmodal.component.html',
  styleUrls: ['./solderdepotmodal.component.css']
})
export class SolderdepotmodalComponent implements OnInit {
  @ViewChild('content') modal: TemplateRef<any>;

  private totalVendu: number=0;
  private totalAPayer: number=0;
  private clientCourant: Personne;

  constructor(private appService: AppService) { }

  ngOnInit() {
    this.appService.soldeModal = this.modal;
  }

  initSoldeDepot(client: Personne) {
    for(let article of this.appService.articlesVendus) {
      this.totalVendu += parseFloat(article.prixVente);
    }
    for(let article of this.appService.articlesNonVendus) {
      this.totalAPayer += parseFloat(article.prixVente);
    }
    this.clientCourant=client;
  }

}
